import * as React from 'react';
import { Upload } from 'antd';
import { imageUrl } from '../../../../config/config';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

interface IUploadInputProps {
  accept: string;
  action: string;
  listType: 'picture' | 'text' | 'picture-card' | undefined;
  value?: string | null;
  placeholder?: string;
  onChange: Function;
}

class UploadInput extends React.Component<IUploadInputProps> {

  public render() {
    return (
      <div>
        <div style={{ float: 'left' }}>
          <Upload
            accept={this.props.accept}
            action={this.props.action}
            listType={this.props.listType || undefined}
            showUploadList={false}
            onChange={({ file }: any) => {
              if (file && file.response && file.response.file) {
                this.props.onChange(file.response.file);
              }
            }}
          >
            <div style={{ position: 'relative' }}>
              {this.props.value
                ? <img src={imageUrl + '/static/' + this.props.value} alt={this.props.placeholder} style={{ maxWidth: '200px', maxHeight: '200px' }} />
                : <React.Fragment>
                  <PlusOutlined />
                  <div className="ant-upload-text">Upload</div>
                </React.Fragment>}
            </div>
          </Upload>
        </div>
        {this.props.value &&
          <div style={{ float: 'left' }}>
            <CloseOutlined
              title={'Remove'}
              onClick={() => this.props.onChange(null)}
              style={{ fontSize: '12px', cursor: 'pointer' }}
            />
          </div>}
      </div>
    );
  }
}

export default UploadInput;


// WEBPACK FOOTER //
// ./src/components/Form/components/UploadInput/UploadInput.tsx